export const getCampaignsByUserAndOrganization = /* GraphQL */ `
  query GetCampaignsByUserAndOrganization(
    $userId: ID!
    $organizationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCampaignsByUserAndOrganization(
      userId: $userId
      organizationId: { eq: $organizationId }
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        agentId
        userId
        status
        jobDescription
        jobDescriptionText
        jobDescriptionParsed {
          jobTitle
          employerName
          location
          summaryOfRole
          contractType
        }
        questions {
          content
          isMandatory
          hasPreferredAnswer
          preferredAnswerRequirements
          preferredAnswerText
          expectedAnswer
        }
        additionalContext
        meetingUrl
        csvS3Key
        createdAt
        updatedAt
        owner
        agent {
          id
          name
        }
        user {
          id
          name
        }
        totalConversationsCount
        totalProspectsCount
        totalConversationsWithRepliesCount
        totalMessagesWithMeetingUrlCount
        totalMessagesWithCallRequest
        totalMessagesWithCustomRequest
        initialMessagesDeliveredCount
        closingMethod
        totalMessagesCount
        organizationId
        candidateBatchId
        launchScheduleDateTime
        channel
        needsReview
        title
        type
        atsListId
        atsJobId
        launchedAt
        workflowId
      }
    }
  }
`;

export const getCampaignsByOrganization = /* GraphQL */ `
  query GetCampaignsByOrganization(
    $organizationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCampaignsByOrganization(
      organizationId: $organizationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        agentId
        userId
        user {
          id
          name
        }
        organizationId
        status
        jobDescription
        jobDescriptionText
        jobDescriptionParsed {
          jobTitle
          employerName
          location
          summaryOfRole
          contractType
        }
        additionalContext
        meetingUrl
        contactNumber
        csvS3Key
        templateId
        createdAt
        totalProspectsCount
        totalConversationsCount
        totalConversationsWithRepliesCount
        initialMessagesSentCount
        totalMessagesCount
        totalMessagesWithMeetingUrlCount
        totalMessagesWithCallRequest
        totalMessagesWithCustomRequest
        messagesProcessedCount
        initialMessagesDeliveredCount
        closingMethod
        updatedAt
        launchedAt
        owner
        candidateBatchId
        launchScheduleDateTime
        channel
        needsReview
        title
        type
        atsListId
        atsJobId
        workflowId
      }
      nextToken
    }
  }
`;

export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      type
      agentId
      agent {
        id
        name
      }
      user {
        id
        name
      }
      userId
      status
      jobDescription
      jobDescriptionText
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        summaryOfRole
        contractType
      }
      additionalContext
      questions {
        content
        isMandatory
        documentTypes
        questionType
        hasPreferredAnswer
        preferredAnswerRequirements
        preferredAnswerText
        expectedAnswer
        order
      }
      calendarMeetingTemplate {
        id
        title
      }
      meetingUrl
      contactNumber
      csvS3Key
      createdAt
      updatedAt
      owner
      totalConversationsCount
      totalProspectsCount
      totalConversationsWithRepliesCount
      totalMessagesWithMeetingUrlCount
      totalMessagesWithCallRequest
      totalMessagesWithCustomRequest
      totalNotInterestedConversationCount
      totalOptedOutConversationCount
      closingMethod
      totalMessagesCount
      organizationId
      candidateBatchId
      launchScheduleDateTime
      messagesProcessedCount
      initialMessagesDeliveredCount
      initialMessagesUndeliveredCount
      initialMessagesReadCount
      initialMessagesSentCount
      templateId
      timeToAutoCloseConversationsInHours
      closingMessage
      customRequest
      title
      channel
      averageTimeToFirstResponse
      averageTimeToComplete
      outreachDescription
      atsListId
      atsJobId
      atsJobPostingId
      followUpMessage
      rejectionMessage
      webChatTemplateId
      conversationCompletedMessage
      customTemplatedMessage
      customTemplatedSubjectLine
      calendarMeetingTemplateId
      isParent
      campaignGroupId
      externalId
      disableNudging
      workflowId
    }
  }
`;

export const getOutreachQuestions = /* GraphQL */ `
  query GetOutreachQuestions($outreachDescription: String!) {
    getOutreachQuestions(outreachDescription: $outreachDescription) {
      outreachDescription
      outreachQuestions {
        content
        supportingInformation
        isMandatory
        __typename
      }
      __typename
    }
  }
`;

export const generateQuestions = /* GraphQL */ `
  query GenerateQuestions($content: String!) {
    generateQuestions(content: $content) {
      closedQuestions {
        content
        __typename
      }
      openEndedQuestions {
        content
        preferredAnswer
        __typename
      }
      __typename
    }
  }
`;

export const getCampaignSubscriptionsByCampaign = /* GraphQL */ `
  query GetCampaignSubscriptionsByCampaign(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCampaignSubscriptionsByCampaign(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        campaignId
        userId
        organizationId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getCampaignSubscriptionsByUserAndOrganization = /* GraphQL */ `
  query GetCampaignSubscriptionsByUserAndOrganization(
    $userId: ID!
    $organizationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCampaignSubscriptionsByUserAndOrganization(
      userId: $userId
      organizationId: { eq: $organizationId }
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        campaign {
          id
          agentId
          userId
          user {
            id
            name
          }
          organizationId
          status
          jobDescription
          meetingUrl
          contactNumber
          csvS3Key
          templateId
          createdAt
          totalProspectsCount
          totalConversationsCount
          totalConversationsWithRepliesCount
          initialMessagesSentCount
          totalMessagesCount
          totalMessagesWithMeetingUrlCount
          totalMessagesWithCallRequest
          totalMessagesWithCustomRequest
          messagesProcessedCount
          initialMessagesDeliveredCount
          closingMethod
          updatedAt
          launchedAt
          owner
          candidateBatchId
          launchScheduleDateTime
          channel
          needsReview
          title
          type
          atsListId
          atsJobId
        }
      }
      nextToken
    }
  }
`;

export const exportCampaignData = /* GraphQL */ `
  query ExportCampaignData($campaignId: ID!) {
    exportCampaignData(campaignId: $campaignId) {
      url
    }
  }
`;
